var _rect, _rect2, _text, _path, _rect3, _text2, _rect4, _text3, _rect5, _text4, _rect6, _text5, _rect7, _text6, _text7, _polygon, _rect8, _text8, _text9, _rect9, _text0, _text1, _line, _text10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcmDoorLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 650,
    viewBox: "0 0 1200 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "CCM door layout",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 650,
    fill: "#6EA7D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 120,
    width: 540,
    height: 360,
    fill: "none",
    stroke: "#2E5C86",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 310,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 34,
    fill: "#0B2236"
  }, "CCM layout")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 70 H360 V120 H330 V480 H190 Z",
    fill: "none",
    stroke: "#2E5C86",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 230,
    width: 85,
    height: 12,
    fill: "#E9E7A2"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 225,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236"
  }, "Door 5")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 535,
    width: 12,
    height: 75,
    fill: "#E9E7A2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 625,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236",
    transform: "rotate(-90 70 625)"
  }, "Door 1")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 255,
    width: 120,
    height: 10,
    fill: "#E9E7A2"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 985,
    y: 248,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236"
  }, "Door 3")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 265,
    width: 85,
    height: 10,
    fill: "#E9E7A2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1095,
    y: 258,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236"
  }, "Door 4")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 410,
    width: 260,
    height: 10,
    fill: "#E9E7A2"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 402,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236"
  }, "Door 2")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 420,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236"
  }, "Speaker")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "215,455 227,480 255,483 234,501 240,528 215,514 190,528 196,501 175,483 203,480",
    fill: "#9BE36B",
    stroke: "#0B2236",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 85,
    width: 55,
    height: 95,
    fill: "#F3B61F",
    stroke: "#2E5C86",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 105,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fill: "#0B2236",
    transform: "rotate(90 262 105)"
  }, "Control")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 132,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fill: "#0B2236",
    transform: "rotate(90 262 132)"
  }, "Rm 2")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 500,
    width: 85,
    height: 58,
    fill: "#F3B61F",
    stroke: "#2E5C86",
    strokeWidth: 2
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 525,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fill: "#0B2236"
  }, "Control")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 545,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fill: "#0B2236"
  }, "Rm 1")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 600,
    x2: 660,
    y2: 560,
    stroke: "#D97D2D",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 625,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fill: "#0B2236"
  }, "main entrance")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcmDoorLayout);
export default __webpack_public_path__ + "static/media/ccm-door-layout.c8cbf6b4f3415b0f4c2fcec7d88f22dd.svg";
export { ForwardRef as ReactComponent };